<template>
    <transition name="fade" @before-leave="beforeLeaveHandler">
        <div class="login-pop">
            <div class="main">
                <Icon type="md-close" class="close-icon" @click="$emit('close-login')"></Icon>
                <div class="left-box">
                    <div class="title">登录后查看更多精彩内容</div>
                    <img class="logo" src="@/assets/images/logo@2x.png" />
                    <div class="qrcode-box">
                        <div class="qrcode-img">
                            <img v-if="!!wechat_qrcode" style="width: 100%" :src="wechat_qrcode">
                        </div>
                        <div class="text">可用 <img class="wechat-ico" src="@/assets/images/icon-wechat-loginpop.png" />
                            <span>微信</span>扫码直接登录
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="right-box">
                    <div class="title">手机号登录</div>
                    <div class="form-content">
                        <div class="form-item">
                            <div class="mobile-prefix">+86</div>
                            <input style="margin-left:10px;" v-model="form_data.mobile" placeholder="请输入手机号码" />
                        </div>
                        <div class="form-item" v-if="login_method === 'sms' || form_scene === 'register'">
                            <input style="margin-left:20px;" v-model="form_data.code" placeholder="请输入手机验证码" />
                            <sms-code class="btn-code" :mobile="form_data.mobile"></sms-code>
                        </div>
                        <template v-if="login_method === 'account' || form_scene === 'register'">
                            <div class="form-item">
                                <input style="margin-left:20px;" v-model="form_data.password"
                                    :placeholder="form_scene === 'register' ? '请设置登录密码' : '请输入登录密码'"
                                    :type="password_type" />
                                <div style="margin-right:20px;">
                                    <img @click="password_type = password_type == 'text' ? 'password' : 'text'"
                                        :src="password_type == 'text' ? require('@/assets/images/icon-open-eye.png') : require('@/assets/images/icon-close-eye.png')"
                                        style="width:18px;height:12px;" />
                                </div>
                            </div>
                            <div v-show="login_method === 'account' && form_scene === 'login'" class="form-item">
                                <input style="margin-left:20px;" v-model="form_data.captcha_code"
                                    placeholder="请输入右侧验证码" />
                                <span class="btn-code" :style="{top:'6px',marginRight:login_method === 'account' ? '20px' : '0'}">
                                    <captcha-img ref="captchaImg" class="captcha" :width="90" :height="35">
                                    </captcha-img>
                                </span>
                            </div>
                        </template>
                        <div
                            style="display:flex;justify-content:space-between;align-items: center;margin-top:10px;flex:1;">
                            <div v-if="form_scene === 'login'"
                                @click="login_method = login_method === 'sms' ? 'account' : 'sms'" class="login-mode">
                                {{ login_method === 'sms' ? '密码登录' : '验证码登录' }}</div>
                        </div>
                    </div>
                    <div class="btn-submit" @click="submit">登录</div>
                    <img v-if="form_scene == 'register'" src="@/assets/images/icon-wx-login.png"
                        style="width:40px;height:40px;margin-bottom:14px;cursor:pointer;"
                        @click="login_mode = 'qrcode'" />
                    <div style="color:#B1B2B3;font-size:12px;width:100%;text-align:center;">
                        <Checkbox v-model="is_agree"></Checkbox>注册登录即代表同意 <span class="cursor" style="color:#000000;" @click="open_agreement">《用户协议》、《个人信息保护政策》
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import {mapState} from 'vuex'
import BindPhone from '@/components/BindPhone/BindPhone.vue';
import CaptchaImg from "@/components/CaptchaImg.vue";
import SmsCode from "@/components/SmsCode.vue";
import {
    AccountLogin,
    MobileLogin,
    Register,
    Profile,
    GetWechatPublicQrcode,
    QueryOpenId,
    QueryWechat,
    LoginByOpenid
} from "@/api/index.js"
import util from '@/utils/util'
export default {
    name: "LoginPop",
    components: {
        CaptchaImg,
        SmsCode,
        BindPhone,
    },
    data() {
        return {
            wechat_qrcode: '',
            form_data_qrcode: {
                key: '',
                openid: '',
                mobile: '',
                code: '',
            },
            form_data: {
                mobile: '',
                code: '',
                password: '',
                captcha_code: '',
            },
            is_agree:false,
            is_password_show: false,
            login_mode: 'form',
            form_scene: 'login',
            login_method: 'sms',
            password_type: 'password',
            show_bind_form: false,
            is_qrcode_expire: true,
            interval_id: null,
            is_popup_show: false,
            is_click: false,
        };
    },
    computed: {
        ...mapState({
            parent_code: (state) => state.parent_code,
            channel: (state) => state.channel,
        }),

	},
    watch:{
        is_agree(news,olds){
            console.log('news',this.is_agree);
        }
    },
    mounted() {
        // 锁定页面滚动
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        // document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.documentElement.style.overflow = 'hidden';
        this.wechatLogin();
    },
    beforeDestroy() {
        document.body.style.overflow = '';
        document.body.style.height = '';
        // document.body.style.position = '';
        document.body.style.width = '';
        document.documentElement.style.overflow = '';
    },
    methods: {
        submit() {
				if(this.is_click) {
					return
				}
                if(!this.is_agree){
                    this.$layer.msg('请先同意用户协议与个人信息保护政策');
                    return;
                }
				if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account' && this.form_data.captcha_code.length === 0) {
					this.$layer.msg(`请输入验证码`)
					return
				}
				this.is_click = true
				let promise = new Promise(((resolve, reject) => {
					let response
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account') {
						this.form_data.captcha_id = this.$refs.captchaImg ? this.$refs.captchaImg.captcha_id : ''
						response = AccountLogin(this.form_data)
						resolve(response)
					}
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'sms') {
						response = MobileLogin(this.form_data)
						resolve(response)
					}
					if(this.login_mode === 'form' && this.form_scene === 'register') {
                        this.form_data.parent_code = this.parent_code
                        this.form_data.channel = this.channel
						response = Register(this.form_data);
						resolve(response)
					}
					reject({msg: `登录/注册选项异常`})
				}))
				promise.then(response => {
					this.$store.commit('login', response.data)
					return Profile()
				}).then(response => {
					this.$store.commit('setUserInfo', response.data)
				}).then(() => {
					// this.$router.replace({name: 'WorkBench'})
                    this.$store.dispatch('getUser');
                    this.$emit('close-login');
				})
				promise.catch((res)=>{
					this.$layer.msg(res.msg)
					// 图形验证码一次性消费，账号登录失败后必须换图并清空输入
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account' && this.$refs.captchaImg) {
						this.form_data.captcha_code = ''
						this.$refs.captchaImg.refresh()
					}
				})
				promise.finally(() => {
					this.is_click = false
				})
			},
        close_agreement() {
				this.is_popup_show = false
			},
			open_agreement() {
				this.is_popup_show = true
			},
			async qrcode_login(data) {
				return LoginByOpenid({
					openid: this.form_data_qrcode.openid,
					key: this.form_data_qrcode.key,
					mobile: data.mobile,
					code: data.code,
					channel: this.channel,
				}).then(response => {
					this.$store.commit('login', response.data)
					return Profile()
				}).then(response => {
					this.$store.commit('setUserInfo', response.data)
                    this.$emit('close-login');
					// this.$router.replace({name: 'WorkBench'})
				}).catch((res)=>{
					this.$layer.msg(res.msg)
				})
			},
        toggle_password() {
				this.is_password_show = !this.is_password_show;
			},
        wechatLogin() {
            this.form_data_qrcode.key = util.uuid()
            GetWechatPublicQrcode({ key: this.form_data_qrcode.key }).then(response => {
                this.is_qrcode_expire = false
                this.wechat_qrcode = response.data.url
                this.interval_id = setInterval(() => {
                    QueryOpenId({ key: this.form_data_qrcode.key }).then(res => {
                        if (res.data.openid) {
                            this.form_data_qrcode.openid = res.data.openid
                            clearInterval(this.interval_id)
                            return QueryWechat({
                                openid: this.form_data_qrcode.openid,
                            })
                        }
                        return Promise.reject(-1)
                    }).then(res => {
                        if (res.data.is_need_bind) {
                            this.show_bind_form = true
                            return Promise.reject(-1)
                        }
                        return this.qrcode_login({})
                    })
                }, 3000)
            }).catch((res) => {
                this.$layer.msg(res.msg)
            })
        },
        beforeLeaveHandler(el) {
            // 定义随机方向参数
            const dx = (Math.random() - 0.5) * 200; // 水平方向随机偏移（-100~+100）
            const dy = (Math.random() - 0.5) * 100; // 垂直方向随机偏移（-50~+50）
            const scale = Math.random() * 0.5 + 0.1; // 随机缩放比例（0.1~0.6）

            // 动态设置元素样式
            el.style.transition = "all 0.3s ease-out";
            el.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
            el.style.opacity = "0";
        },
    },
};
</script>
<style lang="scss" scoped>
.login-pop {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.25);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 201;
    overflow-y: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    &::-webkit-scrollbar {
        display: none;
    }

    // overflow:hidden;
    transform-origin: center;
    animation: centerExpand 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    /* 添加缓动曲线 */
    @keyframes centerExpand {
        0% {
            transform: scale(0.8) translateY(-10px);
            /* 初始状态缩小+上移 */
            opacity: 0;
        }

        100% {
            transform: scale(1) translateY(0);
            /* 完全显示 */
            opacity: 1;
        }
    }

    &.fade-leave-active {
        transition: all 0.3s ease-out;
    }

    .main {
        background: #ffffff;
        border-radius: 15px;
        position: relative;
        width: 800px;
        height: 480px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .close-icon {
            position: absolute;
            top: 30px;
            right: 30px;
            font-size: 19px;
            cursor: pointer;
        }

        .left-box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;

            .title {
                background: #ebf3fe;
                border-radius: 24px;
                color: #3d8af5;
                font-size: 15px;
                padding: 17px 25px;
            }

            .logo {
                width: 107px;
                height: 30px;
                margin-top: 23px;
            }

            .qrcode-box {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;

                // padding-top:29px;
                .title {
                    color: #191920;
                    font-size: 16px;
                    width: 100%;
                    text-align: center;
                }

                .qrcode-img {
                    width: 177px;
                    height: 177px;
                    margin-top: 21px;
                    box-shadow: 0px 3px 9px 3px #D1d1d1;
                    border-radius: 10px;
                }

                .text {
                    color: #3c3c3c;
                    margin: 21px 0;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;

                    span {
                        color: #3c3c3c;
                        font-size: 18px;
                        font-weight: bold;
                    }

                    .wechat-ico {
                        width: 26px;
                        height: 26px;
                    }
                }
            }
        }

        .line {
            width: 1px;
            height: 100%;
            background: #ebebeb;
        }

        .right-box {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .title {
                color: #414141;
                font-size: 18px;
                font-weight: bold;
                margin-bottom:47px;
            }

            .btn-submit {
                margin: 40px 0 45px 0;
                width: 280px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                background: #FA3D5A;
                color: white;
                border-radius: 23px;
                cursor: pointer;
            }

            .form-content {
                width: 100%;
                margin-top: 0px;
                padding:0 50px;

                .form-item {
                    background: #F7F7F7;
                    width: 100%;
                    height: 50px;
                    border-radius: 25px;
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    box-sizing: border-box;

                    input {
                        border: none !important;
                        background: transparent;
                        outline: none !important;
                        width: 93%;

                        &:focus {
                            border: none !important;
                        }

                        &:active {
                            border: none !important;
                        }
                    }

                    .btn-code {
                        white-space: nowrap;
                    }

                    .mobile-prefix {
                        border-right: 1px solid #E4E4E4;
                        padding-left: 20px;
                        padding-right: 15px;
                        flex: 0 0 5%;
                        color: #2C2E30;
                        font-size: 14px;
                    }
                }

                .under-form {
                    margin-top: 10px;
                    flex: 1;

                    .login-mode {
                        margin-left: 20px;
                        cursor: pointer;

                        .forget-pwd {
                            color: #303234;
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}
</style>
